import { Paper, Tab, Tabs } from "@material-ui/core";
import React from "react";
import { CreateExercise } from "./views/exercises/CreateExercise";
import { NavLink, Route, Switch, useLocation } from "react-router-dom";
import { Area } from "types";
import { CataloguePath } from "routes/createContent/paths";
import { EditExercise } from "./views/exercises/EditExercise";
import { ExerciseRoutes } from "./views/exercises/ExerciseRoutes";
import Lessons from "./views/lessons";

const tabs = [
  Area.CreateContent_NewExercise,
  Area.CreateContent_EditExercise,
  CataloguePath.Exercises,
  CataloguePath.Lessons,
];

export const CreateContent: React.VFC = () => {
  const { pathname } = useLocation();
  const tab = tabs.find(area => pathname === area || pathname.startsWith(`${area}/`)) ?? false;

  return (
    <Paper style={{ padding: "16px", margin: "16px auto", backgroundColor: "#fff", maxWidth: "1200px" }}>
      <Tabs value={tab} style={{ marginBottom: 32 }}>
        <Tab
          label="New Exercise"
          component={NavLink}
          to={Area.CreateContent_NewExercise}
          value={Area.CreateContent_NewExercise}
        />
        <Tab
          label="Edit Exercise"
          component={NavLink}
          to={`${Area.CreateContent_EditExercise}`}
          value={Area.CreateContent_EditExercise}
        />
        <Tab label="Exercises" component={NavLink} to={CataloguePath.Exercises} value={CataloguePath.Exercises} />
        <Tab label="Lessons" component={NavLink} to={CataloguePath.Lessons} value={CataloguePath.Lessons} />
      </Tabs>
      <Switch>
        <Route path={Area.CreateContent_NewExercise}>
          <CreateExercise />
        </Route>
        <Route path={`${Area.CreateContent_EditExercise}`} exact>
          <EditExercise />
        </Route>
        <Route path={`${Area.CreateContent_EditExercise}/:id`}>
          <EditExercise />
        </Route>
        <Route path={CataloguePath.Exercises}>
          <ExerciseRoutes />
        </Route>
        <Route path={CataloguePath.Lessons}>
          <Lessons />
        </Route>
      </Switch>
    </Paper>
  );
};
